import React from 'react';

import SocialMenu from '../SocialMenu';

export default function InsceneSocialMenu(props) {
    return (
        <SocialMenu
            twitter="https://twitter.com/netwerkapp"
            facebook="https://www.facebook.com/Netwerkapp"
            linkedin="https://www.linkedin.com/company/10210459"
            web="https://www.networkapp.eu"
        />
    );
}
